<header>
  <app-menu class="container-fluid bg-light nav-custom fixed-top"></app-menu>
</header>
<div class="mt-5">
  <router-outlet></router-outlet>
</div>
<app-footer-component></app-footer-component>

